/**
 * Whether the forgot-password page should show its neutral "if an account
 * exists" confirmation for a reset request's HTTP status. `status` is
 * undefined when there was no response (network error, timeout).
 *
 * 404 counts as confirmed: API versions before MNT#4223 return it for unknown
 * emails, and showing anything different would reveal whether an account
 * exists. Every other failure (429, 5xx, no response) is unrelated to the
 * email, so the user can safely be asked to try again.
 */
export function showsPasswordResetConfirmation(status: number | undefined): boolean {
  if (status === undefined) {
    return false;
  }
  return (status >= 200 && status < 300) || status === 404;
}
